/**
 * This only does basic embedding of maps and can ~probably~ be improved a lot. I will never claim to be a JS expert.
 * Most of the code is taken from https://www.advancedcustomfields.com/resources/google-map/ and then modified.
 * / Björn
 */

export default class EcGoogleMaps {

  static init() {

    jQuery('.ec-google-maps-embed__map').each(function() {

      EcGoogleMaps.initMap($(this));

    });

  }

  static initMap($element) {

    let $markers = $element.find('.marker');

    // Create generic map.
    let mapArgs = {
      zoom        : $element.data('zoom'),
      mapTypeId   : google.maps.MapTypeId.ROADMAP
    };

    let map = new google.maps.Map($element[0], mapArgs);

    // Add markers.
    map.markers = [];
    $markers.each(function(){
      EcGoogleMaps.initMarker(jQuery(this), map);
    });

    // Center map based on markers.
    EcGoogleMaps.centerMap(map);

    // Return map instance.
    return map;

  }

  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */
  static initMarker($marker, map) {

    // Get position from marker.
    let lat = $marker.data('lat');
    let lng = $marker.data('lng');
    let latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng)
    };

    // Create marker instance.
    let marker = new google.maps.Marker({
      position : latLng,
      map: map
    });

    // Append to reference for later use.
    map.markers.push(marker);

    /*// If marker contains HTML, add it to an infoWindow.
    if($marker.html()){

      // Create info window.
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html()
      });

      // Show info window when marker is clicked.
      google.maps.event.addListener(marker, 'click', function() {
        infowindow.open(map, marker);
      });
    }*/

  }

  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */
  static centerMap(map) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function(marker){
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng()
      });
    });

    if(map.markers.length == 1) {
      map.setCenter(bounds.getCenter());
    } else{
      map.fitBounds(bounds);
    }
  }

}

// To be able to call the init
window.EcGoogleMaps = EcGoogleMaps;
